import React from 'react'
import { SvgIcon } from '@mui/material'

export function MicIcon() {
  return (
    <SvgIcon
      viewBox="0 0 34 34"
      sx={{ color: 'transparent', width: '34px', height: '34px' }}
    >
      <path
        d="M17 4.43a3.43 3.43 0 0 0-3.43 3.43V17a3.43 3.43 0 1 0 6.86 0V7.86A3.43 3.43 0 0 0 17 4.43v0Z"
        stroke="#818181"
        strokeWidth="2.29"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 14.71V17a8 8 0 0 1-16 0v-2.29M17 25v4.57M12.43 29.57h9.14"
        stroke="#818181"
        strokeWidth="2.29"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

MicIcon.defaultProps = {
  sx: null,
}
